import React, { Fragment } from 'react';
import SEOMeta from 'containers/SEOMeta';
import AlertSummary from 'containers/AlertSummary';
import MediaSkeleton from 'components/general/Media/MediaSkeleton';
import FilterList from 'components/layouts/FilterList';
import List from './containers/List';
import Filters from './containers/Filters';
import Pagination from './containers/Pagination';
import AlertsPageHeader from './containers/AlertsPageHeader';

const AlertsIndex = () => (
  <Fragment>
    <SEOMeta title="Alerts Index" />
    <FilterList
      headerSlot={
        <AlertsPageHeader />
      }
      listSlot={
        <List
          data-test="alerts-list"
          renderSkeletonItem={() => (
            <MediaSkeleton horizontal />
          )}
          renderItem={AlertSummary}
        />
      }
      filterSlot={
        <Filters />
      }
      actionBarSlot={
        <Pagination />
      }
      paginationSlot={
        <Pagination />
      }
    />
  </Fragment>
);

export default AlertsIndex;
